






import Component from 'vue-class-component';
import FormBase from '@/general/abstract/form/FormBase.vue';
import { DataLoggerFormModel } from '@/context/data_logger/model/form/DataLoggerFormModel';
import DataLoggerForm from '@/context/data_logger/component/DataLoggerForm.vue';
import { dataLoggerApi } from '@/context/data_logger/api/DataLoggerApi';
import { FormContainer } from '@/common/mixin/FormContainer';

@Component({
  components: {
    DataLoggerForm,
    FormBase
  }
})
export default class DataLoggerFormContainer extends FormContainer<DataLoggerFormModel> {
  model!: DataLoggerFormModel;

  async formApi(): Promise<DataLoggerFormModel> {
    return await dataLoggerApi.form<DataLoggerFormModel>(
      DataLoggerFormModel,
      this.$route?.params?.id ? { id: this.$route.params.id } : null
    );
  }
}
